module.exports = __webpack_public_path__ + "static/media/section03_2.c1b4f19b.jpg";